import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { Language } from '../entities/Language';
import { StorageService } from './storage.service';
import { Roles } from './api.service';

@Injectable()
export class HeaderService {

  private title = new BehaviorSubject('IxellWebLab');
  private logo = new BehaviorSubject('');
  private canBack = new BehaviorSubject(false);
  private back = new BehaviorSubject(false);
  private nbProduct = new BehaviorSubject(0);
  private products = new BehaviorSubject('');
  private cartBtnEnabled = new BehaviorSubject(false);
  private langue = new BehaviorSubject(null);
  private role = new BehaviorSubject(Roles.Unknown);
  private scale = new BehaviorSubject('');
  private removeSerie = new BehaviorSubject(false);
  private removeGamme = new BehaviorSubject(false);
  private sidenav: MatSidenav;
  private tchat = new BehaviorSubject('');


  currentTitle = this.title.asObservable();
  currentLogo = this.logo.asObservable();
  currentCanBack = this.canBack.asObservable();
  currentBack = this.back.asObservable();
  currentLangue = this.langue.asObservable();
  currentNbProduct = this.nbProduct.asObservable();
  currentProducts = this.products.asObservable();
  currentCartBtnEnabled= this.cartBtnEnabled.asObservable();
  currentRole = this.role.asObservable();
  currentScale = this.scale.asObservable();
  currentRemoveSerie = this.removeSerie.asObservable();
  currentRemoveGamme = this.removeGamme.asObservable();

  constructor(private storage: StorageService) { }

  changeTitle(title: string) {
    this.title.next(title);
  }

  changeCanBack(canBack: boolean) {
    this.canBack.next(canBack);
  }

  changeLogo(logo: string) {
    if (logo != null && logo != "") {
      logo = logo.replace(".BMP", ".png");
      this.logo.next(logo);
    }
    else
      this.logo.next(null);
  }

  changeBack(back: boolean) {
    this.back.next(back);
  }

  changeRole(role: Roles) {
    this.role.next(role);
  }

  changeLangue(langue: string) {
    this.langue.next(langue);
  }

  changeNbProduct(nbProduct: number) {
    this.nbProduct.next(nbProduct);
  }

  changeProducts(products: string) {
    this.products.next(products);
  }

  changeCartBtnEnabled(isenabled: boolean) {
    this.cartBtnEnabled.next(isenabled);
  }

  changeRemoveSerie(remove: boolean) {
    this.removeSerie.next(remove);
  }

  changeRemoveGamme(remove: boolean) {
    this.removeGamme.next(remove);
  }

  verifyRole() {
    let role: number = Number.parseInt(this.storage.get('role'));
    this.changeRole(role);
  }

  changeScale(scale: string) {
    this.scale.next(scale);
  }
}
